import React from "react";
import { loadingGIF } from "assets";

// Компонент для відображення індикатора завантаження
const Loading = () => {
  return (
    <div className="loader">
      <img src={loadingGIF} className="non-draggable" alt="Завантаження..." />
    </div>
  );
};

export default Loading;
